import React                from 'react';
import cx                   from "classnames";
import StepsToMoving        from '../components/StepsToMoving';
import Calculator           from '../API/calculator';
import { ymElem }           from '../utils/helpers';

function getTableData(lang) {
    return [
        {
            cellTitle: {
                title: lang.TariffsSlide2_tb1,
                count: lang.TariffsSlide2_tb1_1
            },
            cellWeight: {
                count: '50 ' + lang.HomeSecondSlideKG,
                desc: lang.TariffsSlide2_desc1
            },
            cellWork: {
                list: lang.TariffsSlide2_list1
            },
            cellPrice: {
                price: ''
            },
            cellCount1: {
                count: '90',
                desc: '15 ' + lang.TariffCountM2
            },
            cellCount2: {
                count: '700',
                desc: '1 ' + lang.TariffCountH
            },
            cellCount3: {
                count: '175',
                desc: '15 ' + lang.TariffCountM2
            }
        },
        {
            cellTitle: {
                title: lang.TariffsSlide2_tb2,
                count: lang.TariffsSlide2_tb2_1
            },
            cellWeight: {
                count: '50 ' + lang.HomeSecondSlideKG,
                desc: lang.TariffsSlide2_desc1
            },
            cellWork: {
                list: lang.TariffsSlide2_list2
            },
            cellPrice: {
                price: ''
            },
            cellCount1: {
                count: '90',
                desc: '15 ' + lang.TariffCountM2
            },
            cellCount2: {
                count: '700',
                desc: '1 ' + lang.TariffCountH
            },
            cellCount3: {
                count: '175',
                desc: '15 ' + lang.TariffCountM2
            }
        },
        {
            cellTitle: {
                title: lang.TariffsSlide2_tb3,
                count: lang.TariffsSlide2_tb3_1
            },
            cellWeight: {
                count: '50 ' + lang.HomeSecondSlideKG,
                desc: lang.TariffsSlide2_desc1
            },
            cellWork: {
                list: lang.TariffsSlide2_list3
            },
            cellPrice: {
                price: ''
            },
            cellCount1: {
                count: '90',
                desc: '15 ' + lang.TariffCountM2
            },
            cellCount2: {
                count: '800',
                desc: '1 ' + lang.TariffCountH
            },
            cellCount3: {
                count: '200',
                desc: '15 ' + lang.TariffCountM2
            }
        }
    ]
}

export default class Tariff extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            flagNav: 1,
            cellActive: 0,
            table2Item: getTableData(props.lang)
        };
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.lang.langName !== nextProps.lang.langName) {
            this.setState({
                table2Item: getTableData(nextProps.lang)
            })
        }
    }

    setTabNav(val) {
        this.setState({ flagNav: val });
    };

    setCellActive(setClass) {
        this.setState({ cellActive: setClass });
    };

    setTariff = async(value) => {
        let { data, tariffs } = this.props;
        let tariff;

        if(!tariffs) {
            //@TODO СМЕНА ТАРИФА
            this.props.openCalc();
            return;
        }

        tariffs.map((item) => {
            // Выбираем из тиров тариф
            if(value === item.identifier) tariff = item;
        });

        let _tariff = Object.assign({}, data.tariff, {value, name: tariff.name});

        data = Object.assign({}, data, { tariff: _tariff });
        data.stevedores.advanceInfo.price = _tariff.loaders_min_price * data.stevedores.value;

        let tars = Calculator.preparationData(tariffs);
        let groupLength = Calculator.setGroupLength(tars, value);

        data.selectedGroupLengthValue = groupLength.selectedGroupLengthValue;
        data.selectedGroupLength = groupLength.selectedGroupLength;

        let info = await Calculator.prepareData({
            latitude: data.points[0].adress.latitude,
            longitude: data.points[0].adress.longitude,
            userData: data
        });

        this.props.setInfo(info);
        this.props.setData({tariff: _tariff});

        this.props.setGroupLength({
            selectedGroupLengthValue: groupLength.selectedGroupLengthValue,
            selectedGroupLength: groupLength.selectedGroupLength,
        });

        this.props.openCalc();
    };

    setAdvancedService = (value) => {
        this.props.openCalc();
    };

    renderTable2Item = (item, index) => {
        const { lang } = this.props;

        let cellActBind = (par) => {
            return this.setCellActive.bind(this, par);
        };

        return (
            <div className="column item t-2" key={index}>
                <div className="cell cell-title t-border-b-1 item-title not-h">
                    <h2 className="title">{item.cellTitle.title}</h2>
                    <span className="count">{item.cellTitle.count}</span>
                </div>

                <div className={"cell cell-weight item-weight" + (this.state.cellActive === "row2Item1" ? " active" : "")} onMouseEnter={cellActBind("row2Item1")} onMouseLeave={cellActBind(0)}>
                    <span className="count">{item.cellWeight.count}</span>
                    <span className="desc">{item.cellWeight.desc}</span>
                </div>
                <div className={"cell cell-work item-work" + (this.state.cellActive === "row2Item2" ? " active" : "")} onMouseEnter={cellActBind("row2Item2")} onMouseLeave={cellActBind(0)}>
                    <p className="list">{item.cellWork.list}</p>
                </div>
                <div className={"cell cell-price item-price" + (this.state.cellActive === "row2Item3" ? " active" : "")} onMouseEnter={cellActBind("row2Item3")} onMouseLeave={cellActBind(0)}>
                    <span className="price">{item.cellPrice.price}</span>
                </div>
                <div className={"cell count item-count" + (this.state.cellActive === "row2Item4" ? " active" : "")} onMouseEnter={cellActBind("row2Item4")} onMouseLeave={cellActBind(0)}>
                    <span className="count">{item.cellCount1.count} <span className="als-rubl">₽</span></span>
                    <span className="desc">{item.cellCount1.desc}</span>
                </div>
                <div className={"cell cell-count item-count" + (this.state.cellActive === "row2Item5" ? " active" : "")} onMouseEnter={cellActBind("row2Item5")} onMouseLeave={cellActBind(0)}>
                    <span className="count">{item.cellCount2.count} <span className="als-rubl">₽</span></span>
                    <span className="desc">{item.cellCount2.desc}</span>
                </div>
                <div className={"cell cell-count item-count" + (this.state.cellActive === "row2Item6" ? " active" : "")} onMouseEnter={cellActBind("row2Item6")} onMouseLeave={cellActBind(0)}>
                    <span className="count">{item.cellCount3.count} <span className="als-rubl">₽</span></span>
                    <span className="desc">{item.cellCount3.desc}</span>
                </div>

                <div className="cell cell-btn item-btn not-h">
                    <button type="button" className="btn btn-primary btn-block" onClick={this.setAdvancedService}>{lang.Order}</button>
                </div>
            </div>
        )
    };

    render() {

        const { lang } = this.props;

        const row1Item1 = cx({
            'cell': true,
            'cell-weight': true,
            'active': this.state.cellActive === 'row1Item1'
        });

        const row1Item2 = cx({
            'cell': true,
            'cell-size': true,
            'active': this.state.cellActive === 'row1Item2'
        });

        const row1Item3 = cx({
            'cell': true,
            'cell-car': true,
            'active': this.state.cellActive === 'row1Item3'
        });

        const row1Item4 = cx({
            'cell': true,
            'cell-type': true,
            'active': this.state.cellActive === 'row1Item4'
        });

        const row1Item5 = cx({
            'cell': true,
            'cell-price': true,
            'active': this.state.cellActive === 'row1Item5'
        });

        const row1Item6 = cx({
            'cell': true,
            'cell-count': true,
            'active': this.state.cellActive === 'row1Item6'
        });

        const row1Item7 = cx({
            'cell': true,
            'cell-count': true,
            'active': this.state.cellActive === 'row1Item7'
        });

        const row1Item8 = cx({
            'cell': true,
            'cell-count': true,
            'active': this.state.cellActive === 'row1Item8'
        });

        const row1Item9 = cx({
            'cell': true,
            'cell-count': true,
            'active': this.state.cellActive === 'row1Item9'
        });

        const row1Item10 = cx({
            'cell': true,
            'cell-count': true,
            'active': this.state.cellActive === 'row1Item10'
        });

        let cellActBind = (par) => {
            return this.setCellActive.bind(this, par);
        };

        let a = (
            <div className="tariff-item">
                <div className="tariff-list">
                    <div className="tariff-table">
                        <div className="column desc">
                            <div className="cell cell-title t-border-b-1 desc-title t-1 not-h">
                                <span className="title">{lang.Tariff}</span>
                            </div>
                            <div className={(row1Item1) + " desc-weight"} onMouseEnter={cellActBind("row1Item1")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_1_desc_2}</span>
                            </div>
                            <div className={(row1Item2) + " desc-size"} onMouseEnter={cellActBind("row1Item2")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled size-list">
                                    <li><span className="title t-1"><i className="icon" />{lang.Tariff_table_1_desc_3_1}</span></li>
                                    <li><span className="title t-2"><i className="icon" />{lang.Tariff_table_1_desc_3_2}</span></li>
                                    <li><span className="title t-3"><i className="icon" />{lang.Tariff_table_1_desc_3_3}</span></li>
                                    <li><span className="title t-4"><i className="icon" />{lang.Tariff_table_1_desc_3_4}</span></li>
                                </ul>
                            </div>
                            <div className={(row1Item3) + " desc-car"} onMouseEnter={cellActBind("row1Item3")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_1_desc_4}</span>
                            </div>
                            <div className={(row1Item4) + " t-border-b-1 desc-type"} onMouseEnter={cellActBind("row1Item4")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_1_desc_5}</span>
                            </div>
                            <div className={(row1Item5) + " desc-price"} onMouseEnter={cellActBind("row1Item5")} onMouseLeave={cellActBind(0)}>
                                <span className="title t-bold">{lang.Tariff_table_1_desc_6}</span>
                            </div>
                            <div className={(row1Item6) + " desc-count"} onMouseEnter={cellActBind("row1Item6")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_1_desc_7}</span>
                            </div>
                            <div className={(row1Item7) + " desc-count"} onMouseEnter={cellActBind("row1Item7")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_1_desc_8}</span>
                            </div>
                            <div className={(row1Item8) + " desc-count"} onMouseEnter={cellActBind("row1Item8")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_1_desc_9}</span>
                            </div>
                            <div className={(row1Item9) + " desc-count"} onMouseEnter={cellActBind("row1Item9")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_1_desc_10}</span>
                            </div>
                            <div className={(row1Item10) + " desc-count"} onMouseEnter={cellActBind("row1Item10")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_1_desc_11}</span>
                            </div>
                        </div>

                        <div className="column item t-1">
                            <div className="cell cell-title t-border-b-1 item-title not-h">
                                <div className="img">
									<div className="img-icon mini"/>
                                </div>
                                <h2 className="title">{lang.CalculatorMin}</h2>
                                <span className="count">700 {lang.HomeSecondSlideKG}</span>
                            </div>
                            <div className={(row1Item1) + " item-weight"} onMouseEnter={cellActBind( "row1Item1")} onMouseLeave={cellActBind(0)}>
                                <span className="count">700 {lang.HomeSecondSlideKG}</span>
                                <span className="desc">{lang.TariffMiniIntro}</span>
                            </div>
                            <div className={(row1Item2) + " t-border-b-2 item-size"} onMouseEnter={cellActBind("row1Item2")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled size-list">
                                    <li>
                                        <span className="count">1,5 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">1 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">1 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">3 {lang.TariffCalcCb}</span>
                                    </li>
                                </ul>
                            </div>
                            <div className={(row1Item3) + " t-border-b-2 item-car"} onMouseEnter={cellActBind("row1Item3")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled clearfix car-list">
                                    <li><span className="icon furgon" />{lang.TariffCarType1}</li>
                                    <li><span className="icon bort" />{lang.TariffCarType3}</li>
                                    <li><span className="icon fermer-bort" />{lang.TariffCarType4}</li>
									<li><span className="icon furgon" />{lang.TariffCarType7}</li>
                                </ul>
                            </div>
                            <div className={(row1Item4) + " t-border-b-1 item-type"} onMouseEnter={cellActBind("row1Item4")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled clearfix type-list">
                                    <li>{lang.TariffGoodType1}</li>
                                    <li>{lang.TariffGoodType2}</li>
                                    <li>{lang.TariffGoodType3}</li>
                                </ul>
                            </div>
                            <div className={(row1Item5) + " item-price"} onMouseEnter={cellActBind("row1Item5")} onMouseLeave={cellActBind(0)}>
                                <span className="price">{lang.TariffCarSize3}</span>
                            </div>
                            <div className={(row1Item6) + " item-count"} onMouseEnter={cellActBind("row1Item6")} onMouseLeave={cellActBind(0)}>
                                <span className="count">25 {lang.TariffCountM2}</span>
                                <span className="desc">{lang.TariffGetTime1}</span>
                            </div>
                            <div className={(row1Item7) + " item-count"} onMouseEnter={cellActBind("row1Item7")} onMouseLeave={cellActBind(0)}>
                                <span className="count">1290 <span className="als-rubl">₽</span></span>
                                <span className="desc">1 {lang.TariffCountH2}</span>
                            </div>
                            <div className={(row1Item8) + " item-count"} onMouseEnter={cellActBind("row1Item8")} onMouseLeave={cellActBind(0)}>
                                <span className="count">250 <span className="als-rubl">₽</span></span>
                                <span className="desc">15 {lang.TariffCountM2}</span>
                            </div>
                            <div className={(row1Item9) + " item-count"} onMouseEnter={cellActBind("row1Item9")} onMouseLeave={cellActBind(0)}>
                                <span className="count">{lang.TariffGetTime4}</span>
                                <span className="desc">{lang.TariffGetTime1}</span>
                            </div>
                            <div className={(row1Item10) + " item-count"} onMouseEnter={cellActBind("row1Item10")} onMouseLeave={cellActBind(0)}>
                                <span className="count">50 <span className="als-rubl">₽</span></span>
                                <span className="desc">{lang.TariffGetTime3}</span>
                            </div>
                            <div className="cell cell-btn item-btn not-h">
                                <button type="button" className="btn btn-primary btn-block" onClick={() => {this.setTariff('mini2')}}>{lang.Order}</button>
                            </div>
                        </div>

                        <div className="column item t-1">
                            <div className="cell cell-title t-border-b-1 item-title not-h">
                                <div className="img">
									<div className="img-icon standart"/>
                                </div>
                                <h2 className="title">{lang.CalculatorStand}</h2>
                                <span className="count">1 {lang.TariffCountT2}</span>
                            </div>
                            <div className={(row1Item1) + " item-weight"} onMouseEnter={cellActBind("row1Item1")} onMouseLeave={cellActBind(0)}>
                                <span className="count">1 {lang.TariffCountT}</span>
                                <span className="desc">{lang.TariffStandIntro}</span>
                            </div>
                            <div className={(row1Item2) + " t-border-b-2 item-size"} onMouseEnter={cellActBind("row1Item2")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled size-list">
                                    <li>
                                        <span className="count">2,5 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">1,5 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">1,8 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">9 {lang.TariffCalcCb}</span>
                                    </li>
                                </ul>
                            </div>
                            <div className={(row1Item3) + " t-border-b-2 item-car"} onMouseEnter={cellActBind("row1Item3")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled clearfix car-list">
                                    <li><span className="icon furgon" />{lang.TariffCarType1}</li>
                                    <li><span className="icon tent" />{lang.TariffCarType2}</li>
                                    <li><span className="icon fullmetall" />{lang.TariffCarType5}</li>
									<li><span className="icon furgon" />{lang.TariffCarType7}</li>
                                </ul>
                            </div>
                            <div className={(row1Item4) + " t-border-b-1 item-type"} onMouseEnter={cellActBind("row1Item4")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled clearfix type-list">
                                    <li>{lang.TariffGoodType1}</li>
                                    <li>{lang.TariffGoodType2}</li>
                                    <li>{lang.TariffGoodType3}</li>
                                    <li>{lang.TariffGoodType4}</li>
                                    <li>{lang.TariffGoodType5}</li>
                                </ul>
                            </div>
                            <div className={(row1Item5) + " item-price"} onMouseEnter={cellActBind("row1Item5")} onMouseLeave={cellActBind(0)}>
                                <span className="price">{lang.TariffCarSize2}</span>
                            </div>
                            <div className={(row1Item6) + " item-count"} onMouseEnter={cellActBind("row1Item6")} onMouseLeave={cellActBind(0)}>
                                <span className="count">30 {lang.TariffCountM2}<span className="time t-1"><i className="icon"></i>10 {lang.TariffCountM2}</span></span>
                                <span className="desc">{lang.TariffGetTime1}</span>
                            </div>
                            <div className={(row1Item7) + " item-count"} onMouseEnter={cellActBind("row1Item7")} onMouseLeave={cellActBind(0)}>
                                <span className="count">1590 <span className="als-rubl">₽</span><span className="time t-1"><i className="icon"></i>100 <span className="als-rubl">₽</span></span></span>
                                <span className="desc">1 {lang.TariffCountH2}</span>
                            </div>
                            <div className={(row1Item8) + " item-count"} onMouseEnter={cellActBind("row1Item8")} onMouseLeave={cellActBind(0)}>
                                <span className="count">250 <span className="als-rubl">₽</span></span>
                                <span className="desc">15 {lang.TariffCountM2}</span>
                            </div>
                            <div className={(row1Item9) + " item-count"} onMouseEnter={cellActBind("row1Item9")} onMouseLeave={cellActBind(0)}>
                                <span className="count">{lang.TariffGetTime4}</span>
                                <span className="desc">{lang.TariffGetTime1}</span>
                            </div>
                            <div className={(row1Item10) + " item-count"} onMouseEnter={cellActBind("row1Item10")} onMouseLeave={cellActBind(0)}>
                                <span className="count">50 <span className="als-rubl">₽</span></span>
                                <span className="desc">{lang.TariffGetTime3}</span>
                            </div>
                            <div className="cell cell-btn item-btn not-h">
                                <button type="button" className="btn btn-primary btn-block" onClick={() => {this.setTariff('standart2')}}>{lang.Order}</button>
                            </div>
                        </div>

                        <div className="column item t-1">
                            <div className="cell cell-title t-border-b-1 item-title not-h">
                                <div className="img">
									<div className="img-icon extra"/>
                                </div>
                                <h2 className="title">{lang.CalculatorExtra}</h2>
                                <span className="count">1,5 {lang.TariffCountT2}</span>
                            </div>
                            <div className={(row1Item1) + " item-weight"} onMouseEnter={cellActBind("row1Item1")} onMouseLeave={cellActBind(0)}>
                                <span className="count">1,5 {lang.TariffCountT}</span>
                                <span className="desc">{lang.TariffExtraIntro}</span>
                            </div>
                            <div className={(row1Item2) + " t-border-b-2 item-size"} onMouseEnter={cellActBind("row1Item2")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled size-list">
                                    <li>
                                        <span className="count">4 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">1,8 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">2 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">14 {lang.TariffCalcCb}</span>
                                    </li>
                                </ul>
                            </div>
                            <div className={(row1Item3) + " t-border-b-2 item-car"} onMouseEnter={cellActBind("row1Item3")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled clearfix car-list">
                                    <li><span className="icon furgon" />{lang.TariffCarType1}</li>
                                    <li><span className="icon tent" />{lang.TariffCarType2}</li>
                                    <li><span className="icon fullmetall" />{lang.TariffCarType5}</li>
									<li><span className="icon furgon" />{lang.TariffCarType7}</li>
                                </ul>
                            </div>
                            <div className={(row1Item4) + " t-border-b-1 item-type"} onMouseEnter={cellActBind("row1Item4")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled clearfix type-list">
                                    <li>{lang.TariffGoodType1}</li>
                                    <li>{lang.TariffGoodType2}</li>
                                    <li>{lang.TariffGoodType3}</li>
                                    <li>{lang.TariffGoodType4}</li>
                                    <li>{lang.TariffGoodType6}</li>
                                    <li>{lang.TariffGoodType5}</li>
                                </ul>
                            </div>
                            <div className={(row1Item5) + " item-price"} onMouseEnter={cellActBind("row1Item5")} onMouseLeave={cellActBind(0)}>
                                <span className="price">{lang.TariffCarSize1}</span>
                            </div>
                            <div className={(row1Item6) + " item-count"} onMouseEnter={cellActBind("row1Item6")} onMouseLeave={cellActBind(0)}>
                                <span className="count">35 {lang.TariffCountM2}<span className="time t-1"><i className="icon"></i>15 {lang.TariffCountM2}</span></span>
                                <span className="desc">{lang.TariffGetTime1}</span>
                            </div>
                            <div className={(row1Item7) + " item-count"} onMouseEnter={cellActBind("row1Item7")} onMouseLeave={cellActBind(0)}>
                                <span className="count">1790 <span className="als-rubl">₽</span><span className="time t-1"><i className="icon"></i>300 <span className="als-rubl">₽</span></span></span>
                                <span className="desc">1 {lang.TariffCountH2}</span>
                            </div>
                            <div className={(row1Item8) + " item-count"} onMouseEnter={cellActBind("row1Item8")} onMouseLeave={cellActBind(0)}>
                                <span className="count">250 <span className="als-rubl">₽</span></span>
                                <span className="desc">15 {lang.TariffCountM2}</span>
                            </div>
                            <div className={(row1Item9) + " item-count"} onMouseEnter={cellActBind("row1Item9")} onMouseLeave={cellActBind(0)}>
                                <span className="count">{lang.TariffGetTime4}</span>
                                <span className="desc">{lang.TariffGetTime1}</span>
                            </div>
                            <div className={(row1Item10) + " item-count"} onMouseEnter={cellActBind("row1Item10")} onMouseLeave={cellActBind(0)}>
                                <span className="count">50 <span className="als-rubl">₽</span></span>
                                <span className="desc">{lang.TariffGetTime3}</span>
                            </div>
                            <div className="cell cell-btn item-btn not-h">
                                <button type="button" className="btn btn-primary btn-block" onClick={() => {this.setTariff('extra2')}}>{lang.Order}</button>
                            </div>
                        </div>

                        <div className="column item t-1">
                            <div className="cell cell-tite t-border-b-1 item-title not-h">
                                <div className="img">
									<div className="img-icon maxi"/>
                                </div>
                                <h2 className="title">{lang.CalculatorMax}</h2>
                                <span className="count">3 {lang.TariffCountT2}</span>
                            </div>
                            <div className={(row1Item1) + " item-weight"} onMouseEnter={cellActBind("row1Item1")} onMouseLeave={cellActBind(0)}>
                                <span className="count">3 {lang.TariffCountT}</span>
                                <span className="desc">{lang.TariffMaxiIntro}</span>
                            </div>
                            <div className={(row1Item2) + " t-border-b-2 item-size"} onMouseEnter={cellActBind("row1Item2")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled size-list">
                                    <li>
                                        <span className="count">4.2 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">2 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">2 {lang.TariffCountM}</span>
                                    </li>
                                    <li>
                                        <span className="count">18 {lang.TariffCalcCb}</span>
                                    </li>
                                </ul>
                            </div>
                            <div className={(row1Item3) + " t-border-b-2 item-car"} onMouseEnter={cellActBind("row1Item3")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled clearfix car-list">
                                    <li><span className="icon furgon" />{lang.TariffCarType1}</li>
                                    <li><span className="icon tent" />{lang.TariffCarType2}</li>
                                    <li><span className="icon bort" />{lang.TariffCarType3}</li>
									<li><span className="icon furgon" />{lang.TariffCarType7}</li>
                                </ul>
                            </div>
                            <div className={(row1Item4) + " t-border-b-1 item-type"} onMouseEnter={cellActBind("row1Item4")} onMouseLeave={cellActBind(0)}>
                                <ul className="list-unstyled clearfix type-list">
                                    <li>{lang.TariffGoodType1}</li>
                                    <li>{lang.TariffGoodType2}</li>
                                    <li>{lang.TariffGoodType3}</li>
                                    <li>{lang.TariffGoodType4}</li>
                                    <li>{lang.TariffGoodType6}</li>
                                    <li>{lang.TariffGoodType5}</li>
                                </ul>
                            </div>
                            <div className={(row1Item5) + " item-price"} onMouseEnter={cellActBind("row1Item5")} onMouseLeave={cellActBind(0)}>
                                <span className="price">{lang.TariffCarSize4}</span>
                            </div>
                            <div className={(row1Item6) + " item-count"} onMouseEnter={cellActBind("row1Item6")} onMouseLeave={cellActBind(0)}>
                                <span className="count">1 {lang.TariffCountH2}<span className="time t-1"><i className="icon" />30 {lang.TariffCountM2}</span></span>
                                <span className="desc">40 {lang.TariffCountM2} {lang.TariffTime}</span>
                            </div>
                            <div className={(row1Item7) + " item-count"} onMouseEnter={cellActBind("row1Item7")} onMouseLeave={cellActBind(0)}>
                                <span className="count">6790 <span className="als-rubl">₽</span><span className="time t-1"><i className="icon" />300 <span className="als-rubl">₽</span></span></span>
                                <span className="desc">3 {lang.TariffCountH2}<span className="time t-1">+ 3 {lang.TariffCountH}</span></span>
                            </div>
                            <div className={(row1Item8) + " item-count"} onMouseEnter={cellActBind("row1Item8")} onMouseLeave={cellActBind(0)}>
                                <span className="count">315 <span className="als-rubl">₽</span></span>
                                <span className="desc">15 {lang.TariffCountM2}</span>
                            </div>
                            <div className={(row1Item9) + " item-count"} onMouseEnter={cellActBind("row1Item9")} onMouseLeave={cellActBind(0)}>
                                <span className="count">1300 <span className="als-rubl">₽</span></span>
                                <span className="desc">{lang.TariffGetTime1}</span>
                            </div>
                            <div className={(row1Item10) + " item-count"} onMouseEnter={cellActBind("row1Item10")} onMouseLeave={cellActBind(0)}>
                                <span className="count">60 <span className="als-rubl">₽</span></span>
                                <span className="desc">{lang.TariffGetTime3}</span>
                            </div>
                            <div className="cell cell-btn item-btn not-h">
                                <button type="button" className="btn btn-primary btn-block" onClick={() => {this.setTariff('maxi2')}}>{lang.Order}</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );

        const row2Item1 = cx({
            'cell': true,
            'cell-weight': true,
            'active': this.state.cellActive === 'row2Item1'
        });

        const row2Item2 = cx({
            'cell': true,
            'cell-work': true,
            'active': this.state.cellActive === 'row2Item2'
        });

        const row2Item3 = cx({
            'cell': true,
            'cell-price': true,
            'active': this.state.cellActive === 'row2Item3'
        });

        const row2Item4 = cx({
            'cell': true,
            'cell-count': true,
            'active': this.state.cellActive === 'row2Item4'
        });

        const row2Item5 = cx({
            'cell': true,
            'cell-count': true,
            'active': this.state.cellActive === 'row2Item5'
        });

        const row2Item6 = cx({
            'cell': true,
            'cell-count': true,
            'active': this.state.cellActive === 'row2Item6'
        });

        let b = (
            <div className="tariff-item">
                <div className="tariff-list">
                    <div className="tariff-table">

                        <div className="column desc">
                            <div className="cell cell-title t-border-b-1 desc-title t-2 not-h">
                                <span className="title">{lang.Tariff}</span>
                            </div>
                            <div className={(row2Item1) + " desc-weight"} onMouseEnter={cellActBind ("row2Item1")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_2_desc_2}</span>
                            </div>
                            <div className={(row2Item2) + " desc-work"} onMouseEnter={cellActBind("row2Item2")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_2_desc_3}</span>
                            </div>
                            <div className={(row2Item3) + " desc-price"} onMouseEnter={cellActBind("row2Item3")} onMouseLeave={cellActBind(0)}>
                                <span className="title t-bold">{lang.Tariff_table_1_desc_6}</span>
                            </div>
                            <div className={(row2Item4) + " desc-count"} onMouseEnter={cellActBind("row2Item4")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_2_desc_5}</span>
                            </div>
                            <div className={(row2Item5) + " desc-count"} onMouseEnter={cellActBind("row2Item5")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_2_desc_6}</span>
                            </div>
                            <div className={(row2Item6) + " desc-count"} onMouseEnter={cellActBind("row2Item6")} onMouseLeave={cellActBind(0)}>
                                <span className="title">{lang.Tariff_table_2_desc_7}</span>
                            </div>
                        </div>

                        {this.state.table2Item.map(this.renderTable2Item)}

                    </div>
                </div>
            </div>
        );

        return (
            <div key="Tariff" className="page page-tariff">
                <div className="s-tariff">
                    <div className="container">
                        <div className="tariff-head">
                            <h1 className="s-index__title">{lang.Tariff_title_page}</h1>
                            <ul className="list-unstyled clearfix type-list">
                                <li className={this.state.flagNav === 1 ? "active" : null} onClick={this.setTabNav.bind(this, 1)}><a href="#">{lang.TariffSlide1}</a></li>
                                <li className={this.state.flagNav === 2 ? "active" : null} onClick={this.setTabNav.bind(this, 2)}><a href="#">{lang.TariffSlide2}</a></li>
                            </ul>
                            <a href="/static/files/tariffs-2022-05-31.pdf" target="_blank" className="link-pdf" onClick={() => ymElem('extLink', 'https://www.mover24.ru/img/tarifi_new.pdf')}><i className="icon"/>{lang.Tariff_link_pdf}</a>
                        </div>

                        <div className="tariff-desc row">
                            <div className="col-6">
                                <p className="desc">{lang.Tariff_desc_page}</p>
                            </div>
                            <div className="col-6">
                                <div className="tariff-questions row">
                                    <div className="col-6">
                                        <div className="tariff-questions-item t-1">
                                            <h4 className="title">{lang.Tariff_question_1_item_title}</h4>
                                            <p className="descrip">{lang.Tariff_question_1_item_desc}</p>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="tariff-questions-item t-2">
                                            <h4 className="title">{lang.Tariff_question_2_item_title}</h4>
                                            <p className="descrip">{lang.Tariff_question_2_item_desc}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="tariff-cnt">

                            { this.state.flagNav === 1 ? a : null}

                            { this.state.flagNav === 2 ? b : null}

                        </div>
                    </div>
                </div>

                <div className="s-index-example">
                    <div className="container">
                        <h2 className="s-index__title">{lang.Tariff_example_title}</h2>

                        <div className="index-example row">
                            <div className="col">
                                <div className="index-example-cnt t-left">
                                    <div className="img">
										<div className="img-icon demand"/>
                                    </div>
                                    <h3 className="title">{lang.Tariff_example_cnt_title}</h3>
                                    <p className="desc">{lang.Tariff_example_cnt_desc}</p>
                                    <div className="type-list-wrapper row">
                                        <div className="col-5">
                                            <ul className="list-unstyled type-list">
                                                <li><i className="icon"/>{lang.Tariff_example_list_item_1}</li>
                                                <li><i className="icon"/>{lang.Tariff_example_list_item_2}</li>
                                                <li><i className="icon"/>{lang.Tariff_example_list_item_3}</li>
                                            </ul>
                                        </div>
                                        <div className="col-7">
                                            <ul className="list-unstyled type-list">
                                                <li><i className="icon"/>{lang.Tariff_example_list_item_4}</li>
                                                <li><i className="icon"/>{lang.Tariff_example_list_item_5}</li>
                                                <li><i className="icon"/>{lang.Tariff_example_list_item_6}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="index-example-img">
									<div className="illustration illustration-1"/>
                                </div>
                                {/*<div className="index-example-cards">
									<div className="index-example-card t-1">
										<h4 className="title">Mover API</h4>
										<p className="desc">Переход на нашу документацию и описание всего функционала</p>
										<div className="more">
											<a href="#" className="index-example__link">Посмотреть документацию</a>
										</div>
									</div>
									<div className="index-example-card t-2"></div>
									<div className="index-example-card t-3"></div>
								</div>*/}
                            </div>
                        </div>
                    </div>
                </div>

                <StepsToMoving lang={lang} />
            </div>
        );
    }
}
